import { useTranslation } from "@pancakeswap/localization"
import { AddIcon, ArrowBackIcon, Balance, Box, Button, ButtonMenu, ButtonMenuItem, ChevronDownIcon, ChevronUpIcon, CogIcon, Flex, FlexGap, Heading, HelpIcon, IconButton, InjectedModalProps, ModalBody, ModalContainer, ModalHeader, ModalTitle, Text, useMatchBreakpoints, useModal, useTooltip } from "@pancakeswap/uikit"
import { FEE_TIERS, FeeAmount, NonfungiblePositionManager, Pool, Position, TickMath, tickToPrice } from "@pancakeswap/v3-sdk"
import { CurrencyLogo } from "components/Logo"
import { useCurrency } from "hooks/Tokens"
import { useCallback, useEffect, useMemo, useState } from "react"
import LiquidityFormProvider from "views/AddLiquidityV3/formViews/V3FormView/form/LiquidityFormProvider"
// import IncreaseLiquidityV3 from 'views/AddLiquidityV3/IncreaseLiquidityV3'
import { hexToBigInt } from "viem"
import { DAI, pDAI } from "@pancakeswap/tokens"
import { ChainId } from "@pancakeswap/chains"
import styled from "styled-components"
import { CurrencySelectButton } from "components/ECurrencyInputPanel"
import { Currency, Price, Token } from "@pancakeswap/swap-sdk-core"
import useNativeCurrency from "hooks/useNativeCurrency"
import useV3DerivedInfo from "hooks/v3/useV3DerivedInfo"
import { Bound } from "config/constants/types"
import { formatCurrencyAmount, formatRawAmount } from "utils/formatCurrencyAmount"
import SettingsModal from "components/EMenu/GlobalSettings/SettingsModal"
import { SettingsMode } from "components/EMenu/GlobalSettings/types"
import { useUserSlippage, useUserSlippagePercent } from "@pancakeswap/utils/user"
import { initialState, MintState, useV3FormDispatch, useV3FormState } from "views/AddLiquidityV3/formViews/V3FormView/form/reducer"
import { Field, resetMintState } from "views/AddLiquidityV3/formViews/V3FormView/form/actions"
import { usePoolData } from "views/V3Info/hooks"
import { V3SubmitButton } from "views/AddLiquidityV3/components/V3SubmitButton"
import useActiveWeb3React from "hooks/useActiveWeb3React"
import { useIsTransactionUnsupported, useIsTransactionWarning } from "hooks/Trades"
import { ApprovalState, useApproveCallback } from "hooks/useApproveCallback"
import { useV3NFTPositionManagerContract } from "hooks/useContract"
import TransactionConfirmationModal from "components/TransactionConfirmationModal"
import useTransactionDeadline from "hooks/useTransactionDeadline"
import { useSendTransaction, useWalletClient } from "wagmi"
import { basisPointsToPercent } from "utils/exchange"
import { getViemClients } from "utils/viem"
import { calculateGasMargin } from "utils"
import { ENumericalInput, LiquidityChartRangeInput, ZOOM_LEVELS, ZoomLevels } from "@pancakeswap/widgets-internal"
import LockedDeposit from "views/AddLiquidityV3/formViews/V3FormView/components/LockedDeposit"
// import { useFeeTierDistribution } from "hooks/v3/useFeeTierDistribution"
import { tryParsePrice } from "hooks/v3/utils"
import { useDensityChartData } from "views/AddLiquidityV3/hooks/useDensityChartData"
import { useV3MintActionHandlers } from "views/AddLiquidityV3/formViews/V3FormView/form/hooks/useV3MintActionHandlers"
import { useRangeHopCallbacks } from "views/AddLiquidityV3/formViews/V3FormView/form/hooks/useRangeHopCallbacks"
import RangeSelector from "views/AddLiquidityV3/formViews/V3FormView/components/RangeSelector"
import useCatchTxError from "hooks/useCatchTxError"
import CurrencySearchModal from "components/SearchModal/CurrencySearchModal"
import { useBUSDCurrencyAmount, useStablecoinPriceAmount } from "hooks/useBUSDPrice"
import { useCurrencyBalance } from "state/wallet/hooks"
import useAccountActiveChain from "hooks/useAccountActiveChain"
import { PoolState } from "hooks/v3/types"
import { useV3Tokens } from "../hooks/usePositions"
import { PoolData, usePoolTiers } from "../hooks/usePools"
import { use9inchPrices, use9mmPrices, useMoralisPrices, usePulseXPrices } from "../hooks/usePrices"

const StyledButton = styled(IconButton)`
  background: #FCFCFD33;
  backdrop-filter: blur(100px);
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin: -20px auto;
  position: relative;
  z-index: 2;
  cursor: pointer;
  &:hover {
    opacity: 0.65;
  }
`

const Info = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  row-gap: 12px;
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`

const ButtonGroup = styled(FlexGap).attrs({ mt: 2 })`
  background: #2B2634;
  padding: 8px;
  gap: 4px;
  // flex: 1;
  border-radius: 16px;
`

const ButtonItem = styled(Flex) <{ checked: boolean }>`
  font-size: small;
  background: ${({ checked, theme }) => checked ? theme.colors.primary : '#FFFFFF0D'};
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  gap: 8px;
  justify-content: center;
  flex-grow: 1;
  // width: 50px;
  &:hover {
    opacity: 0.75;
  }
`

const FeeOptionsContainer = styled(FlexGap)`
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 576px) {
    justify-content: center;
  }
`

const FeeOption = styled(Flex) <{ active: boolean }>`
  color: ${({ active, theme }) => active ? theme.colors.white : theme.colors.textSubtle};
  cursor: pointer;
  border-radius: 12px;
  background: ${({ active, theme }) => active ? theme.colors.primary : "#B7ADD136"};
  box-shadow: ${({ active }) => active ? "none" : "0px 1px 1px 0px #FFFFFF1A inset"};
  align-items: stretch;
  text-align: center;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  flex: 1;
  // min-height: 90px;

  .distribution {
    box-shadow: ${({ active }) => active ? "none" : "0px 1px 1px 0px #FFFFFF1A inset"};
    background: ${({ active }) => active ? "#00000014" : "#B7ADD11A"};
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:not(.disabled):hover {
    opacity: 0.8;
  }
`

const FeePercentage = styled(Text)`
  font-size: 18px;
  // font-weight: bold;
  padding: 8px 4px;

  @media (max-width: 576px) {
    font-size: 16px;
    // padding: 4px 2px;
  }
`

const DistributionText = styled(Text)`
  font-size: 12px;
  line-height: 1.2;

  @media (max-width: 576px) {
    font-size: 10px;
  }
`

const ToolButton = styled(Button)`
  font-size: 14px;
  padding: 8px 12px;
  height: auto;

  @media (max-width: 576px) {
    font-size: 12px;
    padding: 6px 10px;
  }
`

const TabMenu = styled(ButtonMenu)`
  border-radius: 40px;
  align-self: flex-start;
  & > button {
    ${({ scale }) => scale === "xs" && "padding: 6px 16px"}
    ${({ scale }) => scale === "sm" && "padding: 10px 16px"}
    ${({ scale }) => scale === "md" && "padding: 16px"}
  }
`

const TabMenuItem = styled(ButtonMenuItem)`
  height: auto;
  font-size: 14px;
  border-radius: 40px;
`

const PriceBox = styled(Flex)`
  border: 1px solid #F1D1E329;
  background: #0000004D;
  padding: 16px 16px 16px 20px;
  border-radius: 12px;
  justify-content: space-between;
  align-items: baseline;
  input {
    background: transparent;
    border: none;
    outline: none;
    flex: 1;
    font-size: 20px;
    &::placeholder {
      color: ${({ theme }) => theme.colors.textSubtle};
    }
    &:disabled {
      color: ${({ theme }) => theme.colors.textSubtle};
    }
  }
  @media (max-width: 768px) {
    input {
      font-size: 16px;
    }
  }
`

const StyledPriceInput = styled(ENumericalInput)`
  background: transparent;
  border: none;
  outline: none;
  flex: 1;
  font-size: 20px;
  &::placeholder {
    color: ${({ theme }) => theme.colors.textSubtle};
  }
  &:disabled {
    color: ${({ theme }) => theme.colors.textSubtle};
  }
`

const ResponsivePriceBox = styled(PriceBox)`
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    
    input {
      font-size: 16px;
    }
  }
`

const SettingsButton = styled(IconButton)`
  background: #B7ADD11A;
  padding: 8px 12px;
  flex: 1;
  height: auto;
  width: auto;
  border-radius: 12px;
  color: white;
  font-size: 16px;
  white-space: nowrap;
`

const PercentButton = styled(IconButton)`
  background: #B7ADD11A;
  padding: 4px 12px;
  height: auto;
  width: auto;
  border-radius: 12px;
  color: white;
  font-size: 12px;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.textSubtle};
`

const StyledModalContainer = styled(ModalContainer)`
  max-width: 100% !important;
  @media (max-width: 480px) {
    width: 100%;
  }
`

const InputWrapper = styled(Flex)`
  padding: 12px 20px;
  background-color: #0000004D;
  backdrop-filter: blur(4px);
  border-radius: 16px;
  overflow: hidden;
  flex-direction: column;
  align-items: stretch;
  // border: 1px solid rgba(241, 209, 227, 0.16);
  
  @media (max-width: 480px) {
    border-radius: 12px;
    margin-bottom: 4px;
  }
`

const StyledInput = styled(ENumericalInput)`
  background: transparent;
  border: none;
  color: white;
  width: 100%;
  padding: 0;
  font-size: 32px;
  // font-weight: bold;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textSubtle};
  }

  text-align: right;
  @media (max-width: 480px) {
    font-size: 24px;
    // height: 32px;
  }
`

const FeeWrapper = styled(Box)`
  background: #FFFFFF0D;
  border-radius: 16px;
  padding: 16px 20px;
`

const FeeTier = styled(Text)`
  border: 1px solid ${({ theme }) => theme.colors.textSubtle};
  border-radius: 8px;
  padding: 4px 6px;
  width: fit-content;
  opacity: 0.7;
`

const ModalButton = styled(IconButton)`
  // border: 2px solid ${({ theme }) => theme.colors.primary};
  // border-radius: 100%;
  width: 40px;
  height: 40px;
  margin-top: 0;
`;

interface IncreaseModalProps extends InjectedModalProps {
  currencyA?: Currency
  currencyB?: Currency
  poolData?: PoolData
  position?: Position
  // positionDetails: PositionDetails
  // poolStats: PoolData
  // liquidityUSD: number
  // currentPrice: number
  // token0Percentage: number
  // token1Percentage: number
  onDone?: () => void
}

// const formatNumber = (value, precision = 6) => {
//   if (!value) return '0'

//   const k = 1000
//   const sizes = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y']

//   const i = value < 1 ? 0 : Math.floor(Math.log(value) / Math.log(k))

//   return `${parseFloat((value / k ** i).toFixed(i ? 2 : precision))}${sizes[i]}`
// }

const toFormState = (position?: Position) => {
  if (!position)
    return undefined
  const tickLower = Math.round(TickMath.MIN_TICK / position.pool.tickSpacing) * position.pool.tickSpacing
  const tickUpper = Math.floor(TickMath.MAX_TICK / position.pool.tickSpacing) * position.pool.tickSpacing
  return {
    fullRange: tickLower === position.tickLower && tickUpper === position.tickUpper,
    leftRangeTypedValue: position.token0PriceLower,
    rightRangeTypedValue: position.token0PriceUpper
  }
}

const AltIcon = () => {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 8.33333L15.8334 8.33333M10 11.6667L4.1667 11.6667M14.1667 11.6667L16.9108 8.92259C17.2362 8.59715 17.2362 8.06952 16.9108 7.74408L14.1667 5M5.83337 15L3.08929 12.2559C2.76386 11.9305 2.76386 11.4028 3.08929 11.0774L5.83337 8.33333" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
}

const CurrencySelect = ({ currency, otherCurrency, onCurrencySelect }) => {
  const { t } = useTranslation()
  const [onPresentCurrencyModal] = useModal(
    <CurrencySearchModal
      onCurrencySelect={onCurrencySelect}
      selectedCurrency={currency}
      otherSelectedCurrency={otherCurrency}
    />,
  )
  return <CurrencySelectButton
    style={{ flex: 1, justifyContent: 'flex-start', padding: '12px', height: 'auto' }}
    selected={!!currency}
    // disabled={disableCurrencySelect}
    onClick={onPresentCurrencyModal}
  >
    <Flex alignItems="center" className="currency-logo-name-container">
      <CurrencyLogo currency={currency} size="24px" />
      <Text fontSize="14px" className="currency-name" id="pair" style={{ whiteSpace: 'nowrap' }}>
        {(currency && currency.symbol && currency.symbol.length > 10
          ? `${currency.symbol.slice(0, 4)}...${currency.symbol.slice(-5)}`
          : currency?.symbol) || t('Select a currency')}
      </Text>
    </Flex>
    <ChevronDownIcon ml="auto" color="textSubtle" />
  </CurrencySelectButton>
}

const CurrencyInput = ({ currency, value, onInput }) => {
  const { account } = useAccountActiveChain()
  const balance = useCurrencyBalance(account, currency)
  const amountInUSD = useStablecoinPriceAmount(
    currency,
    Number.isFinite(+value) ? +value : undefined,
    {
      hideIfPriceImpactTooHigh: false,
      enabled: Number.isFinite(+value),
    },
  )

  // const amountInUSD = useBUSDCurrencyAmount(
  //   currency,
  //   Number.isFinite(+value) ? +value : undefined,
  // )

  const onPercentInput = useCallback((percent) => {
    if (balance && !balance.equalTo(0)) {
      if (percent === 100)
        onInput(balance.toExact())
      else
        onInput(String(Number(balance.toExact()) * percent / 100))
    }
  }, [balance, onInput])

  return <InputWrapper>
    <StyledInput
      value={value}
      onUserInput={onInput}
      placeholder="0.0"
      decimals={currency?.decimals ?? 18}
    />
    <FlexGap gap="8px" alignItems="center">
      {
        // !!balance && !balance.equalTo(0) &&
        <>
          <PercentButton onClick={() => onPercentInput(25)}>25%</PercentButton>
          <PercentButton onClick={() => onPercentInput(50)}>50%</PercentButton>
          <PercentButton onClick={() => onPercentInput(100)}>MAX</PercentButton>
        </>
      }
      <Balance value={amountInUSD} prefix="$" fontSize="14px" decimals={2} color="textSubtle" ml="auto" />
    </FlexGap>
  </InputWrapper>
}

const priceString = (price: Price<Token, Token>, decimals: number) => {
  if (!price)
    return undefined
  return Number(price.toFixed(decimals)) === 0 ? price.toSignificant(decimals) : price.toFixed(decimals)
}

const IncreaseModal: React.FC<IncreaseModalProps> = ({
  currencyA,
  currencyB,
  poolData: initialPoolData,
  position: existingPosition,
  // positionDetails,
  // poolStats,
  // liquidityUSD,
  // currentPrice,
  // token0Percentage,
  // token1Percentage,
  onDone,
  onDismiss,
}) => {
  const { t, currentLanguage: { locale } } = useTranslation()

  const { account, chainId, isWrongNetwork } = useActiveWeb3React()
  const { data: signer } = useWalletClient()

  const positionManager = useV3NFTPositionManagerContract()

  const native = useNativeCurrency()
  const pdai = useCurrency(pDAI[ChainId.PULSE].address)
  const [moreTier, setMoreTier] = useState(false)
  const [initialized, setInitialized] = useState<boolean>(!!existingPosition)
  const [fee, setFee] = useState<FeeAmount>(initialPoolData ? initialPoolData.feeTier * 10000 : FeeAmount.MEDIUM)
  const [currency0, setCurrency0] = useState<Currency>(currencyA ?? native)
  const [currency1, setCurrency1] = useState<Currency>(currencyB ?? pdai)

  // const [typedAmount0, setTypedAmount0] = useState('')
  // const [typedAmount1, setTypedAmount1] = useState('')
  // const [typedField, setTypedField] = useState<Field>(Field.CURRENCY_A)
  const [attemptingTxn, setAttemptingTxn] = useState<boolean>(false)
  const [txHash, setTxHash] = useState<string>('')

  const { isMobile, isDesktop } = useMatchBreakpoints()

  const { sendTransactionAsync } = useSendTransaction()

  const poolAddress = useMemo(() => {
    if (!currency0 || !currency1)
      return undefined
    return Pool.getAddress(currency0.wrapped, currency1.wrapped, fee)
  }, [currency0, currency1, fee])

  const { data: poolDatas } = usePoolTiers(currency0, currency1)
  const poolData = useMemo(() => poolDatas?.[fee] ?? (initialPoolData?.address?.toLowerCase() === poolAddress?.toLowerCase() ? initialPoolData : undefined), [poolDatas, fee])

  // const [slippage] = useUserSlippagePercent()
  const [allowedSlippage] = useUserSlippage()
  const deadline = useTransactionDeadline()

  // const dispatch = useV3FormDispatch()

  // useEffect(() => {
  //   dispatch(resetMintState())
  // }, [dispatch, currency0, currency1, fee])

  const formState = useV3FormState()

  const { inverted, startPriceTypedValue, typedValue, independentField, leftRangeTypedValue, rightRangeTypedValue } = formState
  const reversed = useMemo(() => !currency0?.wrapped.sortsBefore(currency1?.wrapped), [currency0, currency1])
  const [token0, token1] = useMemo(() => {
    if (reversed)
      return [currency1, currency0]
    return [currency0, currency1]
  }, [currency0, currency1, reversed])

  const { data: priceDataFrom9inch } = use9inchPrices(token0?.wrapped?.address, token1?.wrapped?.address)
  const { data: priceDataFrom9mm } = use9mmPrices(token0?.wrapped?.address, token1?.wrapped?.address)
  const { data: priceDataFromPulseX } = usePulseXPrices(token0?.wrapped?.address, token1?.wrapped?.address)
  const { data: priceDataFromMoralis } = useMoralisPrices(token0?.wrapped?.address, token1?.wrapped?.address)

  const {
    pool,
    poolState,
    ticks,
    dependentField,
    price: price0,
    pricesAtTicks,
    parsedAmounts,
    currencyBalances,
    position,
    noLiquidity: noLiquidity0,
    currencies,
    errorMessage,
    invalidPool,
    invalidRange,
    outOfRange,
    depositADisabled,
    depositBDisabled,
    invertPrice,
    ticksAtLimit,
  } = useV3DerivedInfo(
    currency0,
    currency1,
    fee,
    currency0,
    undefined, // existingPosition,
    formState
  )

  console.log(poolData)

  const noLiquidity = useMemo(() => poolState !== PoolState.LOADING ? noLiquidity0 : (!poolData || poolData.liquidity === 0), [poolState, noLiquidity0, poolData])

  const price = useMemo(() => inverted ? price0?.invert() : price0, [inverted, price0])
  const { [Bound.LOWER]: tickLower, [Bound.UPPER]: tickUpper } = ticks
  const { [Bound.LOWER]: priceLower, [Bound.UPPER]: priceUpper } = pricesAtTicks

  const addIsWarning = useIsTransactionWarning(currencies?.CURRENCY_A, currencies?.CURRENCY_B)
  const addIsUnsupported = useIsTransactionUnsupported(currencies?.CURRENCY_A, currencies?.CURRENCY_B)
  const {
    approvalState: approvalA,
    approveCallback: approveACallback,
    revokeCallback: revokeACallback,
    currentAllowance: currentAllowanceA,
  } = useApproveCallback(parsedAmounts[Field.CURRENCY_A], positionManager?.address)
  const {
    approvalState: approvalB,
    approveCallback: approveBCallback,
    revokeCallback: revokeBCallback,
    currentAllowance: currentAllowanceB,
  } = useApproveCallback(parsedAmounts[Field.CURRENCY_B], positionManager?.address)

  const showApprovalA = approvalA !== ApprovalState.APPROVED && !!parsedAmounts[Field.CURRENCY_A]
  const showApprovalB = approvalB !== ApprovalState.APPROVED && !!parsedAmounts[Field.CURRENCY_B]

  // const formattedAmounts = useMemo(() => ({
  //   [typedField]: typedField === Field.CURRENCY_A ? typedAmount0 : typedAmount1,
  //   [dependentField]: noLiquidity ? (typedField === Field.CURRENCY_A ? typedAmount1 : typedAmount0) : parsedAmounts[dependentField]?.toSignificant(6) ?? '',
  // }), [typedField, typedAmount0, typedAmount1, dependentField, noLiquidity, parsedAmounts])
  const formattedAmounts = useMemo(() => ({
    [independentField]: typedValue,
    [dependentField]: parsedAmounts[dependentField]?.toSignificant(6) ?? '',
  }), [dependentField, independentField, parsedAmounts, typedValue])

  const {
    isLoading: isChartDataLoading,
    error: chartDataError,
    formattedData,
  } = useDensityChartData({
    currencyA: token0,
    currencyB: token1,
    feeAmount: fee,
  })

  const poolAPR = useMemo(() =>
    poolData?.apr1d ?? 0,
    [poolData]
  )

  const { tokenIds, isLoading: positionLoading } = useV3Tokens(account, poolAddress, tickLower, tickUpper)

  const [priceLow24H, priceHigh24H] = useMemo(() => {
    if (poolData && poolData.tickLow24H && poolData.tickHigh24H) {
      const priceLow = tickToPrice(token0?.wrapped, token1?.wrapped, Math.min(pool?.tickCurrent ?? poolData.tickLow24H, poolData.tickLow24H))
      const priceHigh = tickToPrice(token0?.wrapped, token1?.wrapped, Math.max(pool?.tickCurrent ?? poolData.tickHigh24H, poolData.tickHigh24H))
      if (inverted)
        return [priceHigh.invert(), priceLow.invert()]
      return [priceLow, priceHigh]
    }
    return [undefined, undefined]
  }, [pool, token0?.wrapped, token1?.wrapped, inverted, poolData])

  // const { isLoading: isLoadingDistributions, largestUsageFeeTier, distributions } = useFeeTierDistribution(currency0, currency1)
  const currencyUnit = useMemo(() => {
    return t("%symbol1% per %symbol0%", { symbol0: inverted ? token1.symbol : token0.symbol, symbol1: inverted ? token0.symbol : token1.symbol })
  }, [t, token0, token1, inverted])

  const shareOfPool = useMemo(() => noLiquidity
    ? 100
    : poolData
      ? Math.max((Number(formattedAmounts[inverted ? Field.CURRENCY_B : Field.CURRENCY_A]) * 100 / (poolData.reserve0 + Number(formattedAmounts[inverted ? Field.CURRENCY_B : Field.CURRENCY_A]))
        + Number(formattedAmounts[inverted ? Field.CURRENCY_A : Field.CURRENCY_B]) * 100 / (poolData.reserve1 + Number(formattedAmounts[inverted ? Field.CURRENCY_A : Field.CURRENCY_B]))) / 2, 0)
      : 0,
    [noLiquidity, poolData, inverted, formattedAmounts])

  const {
    onNewState,
    onFieldAInput,
    onFieldBInput,
    onLeftRangeInput,
    onRightRangeInput,
    onStartPriceInput,
    onBothRangeInput,
    onInvertPrice,
    onSetFullRange,
  } = useV3MintActionHandlers(noLiquidity)

  const { getDecrementLower, getIncrementLower, getDecrementUpper, getIncrementUpper, getSetFullRange } =
    useRangeHopCallbacks(inverted ? token1 : token0, inverted ? token0 : token1, fee, tickLower, tickUpper, pool)

  const handleDismiss = useCallback(() => {
    onDismiss?.()
  }, [onDismiss])

  const { fetchTxResponse } = useCatchTxError()

  const onAdd = useCallback(async () => {
    if (!chainId || !signer || !account) return

    if (!positionManager || !currency0 || !currency1 || positionLoading) {
      return
    }

    if (position && deadline) {
      setAttemptingTxn(true)

      const useNative = currency1.isNative ? currency1 : currency0.isNative ? currency0 : undefined

      const { calldata, value } = NonfungiblePositionManager.addCallParameters(position, {
        slippageTolerance: basisPointsToPercent(allowedSlippage),
        deadline: deadline.toString(),
        useNative,
        ...(
          tokenIds.length > 0
            ? {
              tokenId: tokenIds[0]
            }
            : {
              recipient: account,
              createPool: noLiquidity,
            }
        )
      })
      const baseAmount = formatRawAmount(
        parsedAmounts[Field.CURRENCY_A]?.quotient?.toString() ?? '0',
        currencies[Field.CURRENCY_A].decimals,
        4,
      )
      const quoteAmount = formatRawAmount(
        parsedAmounts[Field.CURRENCY_B]?.quotient?.toString() ?? '0',
        currencies[Field.CURRENCY_B].decimals,
        4,
      )

      const txn = {
        data: calldata,
        to: positionManager.address,
        value: hexToBigInt(value),
        account,
      }

      getViemClients({ chainId }).estimateGas(txn).then((gas) =>
        fetchTxResponse(() =>
          sendTransactionAsync({
            ...txn,
            gas: calculateGasMargin(gas),
          }),
          {
            type: 'add-liquidity-v3',
            summary: `Add ${baseAmount} ${currencies[Field.CURRENCY_A]?.symbol} and ${quoteAmount} ${currencies[Field.CURRENCY_B]?.symbol}`,
            translatableSummary: {
              text: `Add %baseAmount% %baseSymbol% and %quoteAmount% %quoteSymbol%`,
              data: {
                baseAmount,
                baseSymbol: currencies[Field.CURRENCY_A]?.symbol,
                quoteAmount,
                quoteSymbol: currencies[Field.CURRENCY_B]?.symbol,
              },
            },
          }
        ).then(() => {
          onDone?.()
          onDismiss?.()
        }).catch((e) => {
          console.log('error', e)
        })
      ).finally(() => setAttemptingTxn(false))
    }
  }, [chainId, signer, account, positionManager, currency0, currency1, positionLoading, position, deadline, allowedSlippage, tokenIds, noLiquidity, parsedAmounts, currencies, fetchTxResponse, sendTransactionAsync, onDone, onDismiss])

  const translationData = useMemo(
    () => ({
      amountA: !depositADisabled ? formatCurrencyAmount(parsedAmounts[Field.CURRENCY_A], 4, locale) : '',
      symbolA: !depositADisabled && currencies[Field.CURRENCY_A]?.symbol ? currencies[Field.CURRENCY_A].symbol : '',
      amountB: !depositBDisabled ? formatCurrencyAmount(parsedAmounts[Field.CURRENCY_B], 4, locale) : '',
      symbolB: !depositBDisabled && currencies[Field.CURRENCY_B]?.symbol ? currencies[Field.CURRENCY_B].symbol : '',
    }),
    [depositADisabled, depositBDisabled, parsedAmounts, locale, currencies],
  )

  const pendingText = useMemo(
    () =>
      !outOfRange
        ? t('Supplying %amountA% %symbolA% and %amountB% %symbolB%', translationData)
        : t('Supplying %amountA% %symbolA% %amountB% %symbolB%', translationData),
    [t, outOfRange, translationData],
  )

  const [onPresentSettingsModal] = useModal(<SettingsModal mode={SettingsMode.SWAP_LIQUIDITY} />)
  const [onPresentConfirmModal] = useModal(
    <TransactionConfirmationModal
      minWidth={['100%', null, '420px']}
      title={t('Add Liquidity')}
      // customOnDismiss={}
      attemptingTxn={attemptingTxn}
      hash={txHash}
      content={() => null}
      pendingText={pendingText}
    />,
    false,
    true,
    `confirm-add-${poolAddress}`,
  )

  const onBothRangePriceInput = useCallback(
    (leftRangeValue: string, rightRangeValue: string) => {
      // if (price) {
      //   const currentPrice = parseFloat(price.toSignificant(8))
      //   const initialMin = parseFloat(leftRangeValue) / currentPrice
      //   const initialMax = parseFloat(rightRangeValue) / currentPrice
      //   setZoomLevel({ ...zoomLevel, initialMin, initialMax })
      // }
      if (inverted)
        onBothRangeInput({
          leftTypedValue: tryParsePrice(token1?.wrapped, token0?.wrapped, leftRangeValue),
          rightTypedValue: tryParsePrice(token1?.wrapped, token0?.wrapped, rightRangeValue),
        })
      else
        onBothRangeInput({
          leftTypedValue: tryParsePrice(token0?.wrapped, token1?.wrapped, leftRangeValue),
          rightTypedValue: tryParsePrice(token0?.wrapped, token1?.wrapped, rightRangeValue),
        })
    },
    [token0, token1, onBothRangeInput, inverted],
  )

  const onLeftRangePriceInput = useCallback(
    (leftRangeValue: string) => {
      // if (price) {
      //     const currentPrice = parseFloat(price.toSignificant(8))
      //     setZoomLevel({ ...zoomLevel, initialMin: parseFloat(leftRangeValue) / currentPrice })
      // }
      if (inverted)
        onLeftRangeInput(tryParsePrice(token1?.wrapped, token0?.wrapped, leftRangeValue))
      else
        onLeftRangeInput(tryParsePrice(token0?.wrapped, token1?.wrapped, leftRangeValue))
    },
    [token0, token1, onLeftRangeInput, inverted],
  )

  const onRightRangePriceInput = useCallback(
    (rightRangeValue: string) => {
      // if (price) {
      //   const currentPrice = parseFloat(price.toSignificant(8))
      //   setZoomLevel({ ...zoomLevel, initialMax: parseFloat(rightRangeValue) / currentPrice })
      // }
      if (inverted)
        onRightRangeInput(tryParsePrice(token1?.wrapped, token0?.wrapped, rightRangeValue))
      else
        onRightRangeInput(tryParsePrice(token0?.wrapped, token1?.wrapped, rightRangeValue))
    },
    [token0, token1, onRightRangeInput, inverted],
  )

  const onCurrencyA = (currency: Currency) => {
    if (currency.wrapped.equals(currency1.wrapped)) {
      setCurrency1(currency0)
    } else {
      setInitialized(false)
    }
    setCurrency0(currency)
  }

  const onCurrencyB = (currency: Currency) => {
    if (currency.wrapped.equals(currency0.wrapped)) {
      setCurrency0(currency1)
    } else {
      setInitialized(false)
    }
    setCurrency1(currency)
  }

  const handleButtonSubmit = () => {
    onAdd()
  }

  useEffect(() => {
    if (attemptingTxn)
      onPresentConfirmModal()
  }, [attemptingTxn, onPresentConfirmModal])

  const handleRefresh = useCallback(
    (level?: ZoomLevels) => {
      const defaultZoomLevel = level ?? ZOOM_LEVELS[fee ?? FeeAmount.MEDIUM]
      const currentPrice = priceString(price, 8)
      if (currentPrice) {
        onBothRangePriceInput((Number(currentPrice) * defaultZoomLevel.initialMin).toFixed(18), (Number(currentPrice) * defaultZoomLevel.initialMax).toFixed(18))
      }
    },
    [price, fee, onBothRangePriceInput],
  )

  useEffect(() => {
    if (existingPosition)
      onNewState({
        ...toFormState(existingPosition),
      })
    else if (price && !initialized)
      onBothRangePriceInput((Number(priceString(price, 8)) * 0.5).toFixed(18), (Number(priceString(price, 8)) * 2).toFixed(18))
  }, [existingPosition, onNewState, price, onBothRangePriceInput, initialized])

  // const title = useMemo(() => {
  //   if (editPriceRange)
  //     return t('Price Settings')
  //   return t('%action% %symbol0% - %symbol1% %fee%% Pool', { action: noLiquidity ? 'Create' : 'Add', symbol0: currency0?.symbol, symbol1: currency1?.symbol, fee: fee / 10000 })
  // }, [t, noLiquidity, currency0, currency1, editPriceRange, fee])

  useEffect(() => {
    if (initialized || !poolDatas)
      return
    const mostFee = FEE_TIERS.find(_fee => poolDatas?.[_fee]?.mostPick)
    if (mostFee) {
      setFee(mostFee)
    }
    if (price)
      setInitialized(true)
  }, [initialized, poolDatas, price])

  const currency0Balance = useCurrencyBalance(account ?? undefined, currency0 ?? undefined)
  const currency1Balance = useCurrencyBalance(account ?? undefined, currency1 ?? undefined)

  const { tooltip, tooltipVisible, targetRef } = useTooltip(
    <FlexGap gap="8px" flexDirection="column">
      {
        !!priceDataFrom9inch && priceDataFrom9inch.length > 0 &&
        <Flex flexDirection="column">
          <Text color="textSubtle" fontSize={14} bold>9inch Price</Text>
          {
            priceDataFrom9inch.map((priceData, i) =>
              <FlexGap gap="8px" key={`9inch-price-${i}`} onClick={() => onStartPriceInput(String(inverted ? priceData.token0Price : priceData.token1Price))}>
                <Balance fontSize={12} value={inverted ? priceData.token0Price : priceData.token1Price} decimals={6} />
                <Balance fontSize={12} value={priceData.liquidity} decimals={2} prefix="Liq: $" pack />
              </FlexGap>
            )
          }
        </Flex>
      }
      {
        !!priceDataFrom9mm && priceDataFrom9mm.length > 0 &&
        <Flex flexDirection="column">
          <Text color="textSubtle" fontSize={14} bold>9mm Price</Text>
          {
            priceDataFrom9mm.map((priceData, i) =>
              <FlexGap gap="8px" key={`9mm-price-${i}`} onClick={() => onStartPriceInput(String(inverted ? priceData.token0Price : priceData.token1Price))}>
                <Balance fontSize={12} value={inverted ? priceData.token0Price : priceData.token1Price} decimals={6} />
                <Balance fontSize={12} value={priceData.liquidity} decimals={2} prefix="Liq: $" pack />
              </FlexGap>
            )
          }
        </Flex>
      }
      {
        !!priceDataFromPulseX && priceDataFromPulseX.length > 0 &&
        <Flex flexDirection="column">
          <Text color="textSubtle" fontSize={14} bold>PulseX Price</Text>
          {
            priceDataFromPulseX.map((priceData, i) =>
              <FlexGap gap="8px" key={`pulsex-price-${i}`} onClick={() => onStartPriceInput(String(inverted ? priceData.token0Price : priceData.token1Price))}>
                <Balance fontSize={12} value={inverted ? priceData.token0Price : priceData.token1Price} decimals={6} />
                <Balance fontSize={12} value={priceData.liquidity} decimals={2} prefix="Liq: $" pack />
              </FlexGap>
            )
          }
        </Flex>
      }
      {
        !!priceDataFromMoralis &&
        <Flex flexDirection="column" onClick={() => onStartPriceInput(String(inverted ? priceDataFromMoralis.token0Price : priceDataFromMoralis.token1Price))}>
          <Text color="textSubtle" fontSize={14} bold>Moralis Price</Text>
          <FlexGap gap="8px">
            <Balance fontSize={12} value={inverted ? priceDataFromMoralis.token0Price : priceDataFromMoralis.token1Price} decimals={6} />
          </FlexGap>
        </Flex>
      }
    </FlexGap>,
    {
      placement: 'bottom-end',
    }
  )

  return (
    <StyledModalContainer>
      <ModalHeader>
        <ModalButton
          variant="text"
          scale="sm"
          onClick={(e) => {
            e.stopPropagation();
            onDismiss?.();
          }}
          aria-label="Close the dialog"
          mt={-2}
          ml={-2}
        >
          <ArrowBackIcon color="#877A9F" />
        </ModalButton>
        <ModalTitle>
          <Heading scale="lg" color="#C1BDCB">{t('Add Liquidity')}</Heading>
        </ModalTitle>
        <ModalButton
          variant="text"
          scale="sm"
          onClick={onPresentSettingsModal}
          aria-label="Set the slippage"
          mt={-2}
          ml={-2}
        >
          <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.50036 3.13175C6.50036 2.32252 7.15637 1.6665 7.96561 1.6665H10.0351C10.8443 1.6665 11.5004 2.32252 11.5004 3.13176C11.5004 4.25972 12.7214 4.96468 13.6983 4.4007C14.3991 3.99607 15.2953 4.23619 15.6999 4.93702L16.7346 6.72921C17.1392 7.43004 16.8991 8.32619 16.1983 8.73081C15.2214 9.2948 15.2214 10.7048 16.1983 11.2687C16.8991 11.6734 17.1392 12.5695 16.7346 13.2703L15.6999 15.0625C15.2953 15.7634 14.3991 16.0035 13.6983 15.5989C12.7214 15.0349 11.5004 15.7399 11.5004 16.8679C11.5004 17.6771 10.8443 18.3332 10.0351 18.3332H7.96565C7.15639 18.3332 6.50036 17.6771 6.50036 16.8679C6.50036 15.7399 5.2793 15.0349 4.30245 15.5989C3.60163 16.0035 2.70549 15.7634 2.30086 15.0626L1.26613 13.2704C0.86151 12.5695 1.10163 11.6734 1.80246 11.2687C2.77931 10.7048 2.77931 9.2948 1.80246 8.73081C1.10163 8.32619 0.86151 7.43004 1.26614 6.72921L2.30086 4.93701C2.70549 4.23618 3.60164 3.99607 4.30246 4.40069C5.2793 4.96466 6.50036 4.2597 6.50036 3.13175Z" stroke="#A39CB1" strokeWidth="2" />
            <path d="M12.3337 9.99984C12.3337 11.8408 10.8413 13.3332 9.00035 13.3332C7.15941 13.3332 5.66702 11.8408 5.66702 9.99984C5.66702 8.15889 7.15941 6.6665 9.00035 6.6665C10.8413 6.6665 12.3337 8.15889 12.3337 9.99984Z" stroke="#A39CB1" strokeWidth="2" />
          </svg>
        </ModalButton>
      </ModalHeader>
      <ModalBody p="24px">
        <LiquidityFormProvider>
          <FlexGap gap="20px" flexDirection={["column", "column", "row"]}>
            <FlexGap gap="12px" flexDirection="column">
              <Text fontSize={18}>{t("Choose Token Pair")}</Text>
              <FlexGap justifyContent="space-between" gap="24px" alignItems="center">
                <CurrencySelect
                  currency={currency0}
                  otherCurrency={currency1}
                  onCurrencySelect={onCurrencyA}
                />
                <AddIcon width={32} />
                <CurrencySelect
                  currency={currency1}
                  otherCurrency={currency0}
                  onCurrencySelect={onCurrencyB}
                />
              </FlexGap>
              <FeeWrapper style={{ cursor: "pointer" }} onClick={() => setMoreTier(!moreTier)}>
                <Flex justifyContent="space-between" alignItems="center">
                  <FlexGap gap="12px" flexDirection="column">
                    <Text fontSize={16}>{t("V3 LP - %fee%% fee tier", { fee: fee / 10000 })}</Text>
                    {
                      !moreTier && !!poolDatas?.[fee]?.distribution &&
                      <FeeTier fontSize={13}>{poolDatas?.[fee]?.distribution < 1 ? '< 1' : poolDatas[fee].distribution.toFixed(0)}% {t('Pick')}</FeeTier>
                    }
                  </FlexGap>
                  <FlexGap>
                    <Text fontSize={14}>{moreTier ? t('Less') : t('More')}</Text>
                    {moreTier ? <ChevronUpIcon /> : <ChevronDownIcon />}
                  </FlexGap>
                </Flex>
                {
                  moreTier &&
                  <FeeOptionsContainer>
                    {
                      FEE_TIERS.map((_fee) =>
                        <FeeOption key={_fee} active={fee === _fee} onClick={(e) => {
                          e.stopPropagation()
                          setFee(_fee)
                          setInitialized(true)
                        }} minWidth={["30%", "30%", 0]} maxWidth="30%">
                          <FlexGap alignItems="center" justifyContent="center" flex="1">
                            {poolDatas?.[_fee]?.mostPick && '🔥'}
                            <FeePercentage color="inherit">
                              {_fee / 10000}%
                            </FeePercentage>
                          </FlexGap>
                          <DistributionText className="distribution" color="inherit">
                            {
                              poolDatas?.[_fee]
                                ? poolDatas[_fee].distribution
                                  ? `${poolDatas[_fee].distribution < 1 ? '< 1' : poolDatas[_fee].distribution.toFixed(0)}% ${t('Pick')}`
                                  : t('0% Pick')
                                : t('Not created')
                            }
                          </DistributionText>
                        </FeeOption>
                      )
                    }
                  </FeeOptionsContainer>
                }
              </FeeWrapper>
              {
                isDesktop &&
                <>
                  <Text fontSize={18} mt={2}>{t("Deposit Amount")}</Text>
                  <FlexGap alignItems="center" gap="8px" mt={1} mb={-1}>
                    <CurrencyLogo currency={currency0} />
                    <Text>{currency0?.symbol}</Text>
                    <Balance fontSize="14px" color="textSubtle" value={Number(currency0Balance?.toExact())} decimals={2} />
                  </FlexGap>
                  <LockedDeposit locked={depositADisabled}>
                    <CurrencyInput
                      currency={currency0}
                      value={formattedAmounts[Field.CURRENCY_A]}
                      onInput={onFieldAInput}
                    />
                  </LockedDeposit>
                  <FlexGap alignItems="center" gap="8px" mt={1} mb={-1}>
                    <CurrencyLogo currency={currency1} />
                    <Text>{currency1?.symbol}</Text>
                    <Balance fontSize="14px" color="textSubtle" value={Number(currency1Balance?.toExact())} decimals={2} />
                  </FlexGap>
                  <LockedDeposit locked={depositBDisabled}>
                    <CurrencyInput
                      currency={currency1}
                      value={formattedAmounts[Field.CURRENCY_B]}
                      onInput={onFieldBInput}
                    />
                  </LockedDeposit>
                </>
              }
            </FlexGap>
            <Box width={[, , "500px"]}>
              <FlexGap flexDirection={["column", "column", "row"]} justifyContent="space-between" gap="8px" mb={2}>
                <Text fontSize={18} mr="auto">{noLiquidity ? t("Set Starting Range") : t("Set Price Range")}</Text>
                {
                  // !noLiquidity &&
                  <FlexGap alignItems="center" justifyContent="flex-end" gap="8px">
                    <Text fontSize="12px" color="text">
                      {t("View prices in")}
                    </Text>
                    <Button scale="xs" onClick={() => onInvertPrice(!inverted)} style={{ padding: '3px 12px', height: 'auto', borderRadius: '8px' }}>
                      <AltIcon />
                      {inverted ? token0.symbol : token1.symbol}
                    </Button>
                  </FlexGap>
                }
              </FlexGap>
              {
                noLiquidity &&
                <>
                  <FlexGap gap="12px" alignItems="flex-start" bg="#EEA23E1A" border="1px solid #EEA23E" borderRadius={16} p="16px 20px" mb={3}>
                    <Box mt={1}>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 8V14M12 17V17.01M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" stroke="#EEA23E" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    </Box>
                    <div>
                      <Text fontSize={[14, 14, 18]}>
                        This pool must be initialized before you can add liquidity.
                        To initialize, select a starting price for the pool.
                        Then, enter your liquidity price range and deposit amount.
                        Gas fees will be higher than usual due to the initialization transaction.
                      </Text>
                      <Text fontSize={[14, 14, 18]} bold mt={3}>
                        Fee-on transfer tokens and rebasing tokens are NOT compatible with V3.
                      </Text>
                    </div>
                  </FlexGap>
                  <PriceBox>
                    <StyledPriceInput
                      value={Number(startPriceTypedValue)}
                      onUserInput={(v) => onStartPriceInput(String(v))}
                      placeholder={t("Initial price")}
                      decimals={(inverted ? token0.decimals : token1.decimals) ?? 18}
                      align="left"
                    />
                    {/* <input
                      value={startPriceTypedValue}
                      onChange={(e: any) => onStartPriceInput(e.target.value)}
                      placeholder={t("Initial price")}
                    /> */}
                    <FlexGap gap="4px" alignItems="center">
                      <Text fontSize={[14, 14, 16]} color="textSubtle">
                        {currencyUnit}
                      </Text>
                      <Flex ref={targetRef} alignItems="center">
                        <HelpIcon color="textSubtle" />
                      </Flex>
                    </FlexGap>
                    {tooltipVisible && tooltip}
                  </PriceBox>
                </>
              }
              {
                !!price && !noLiquidity &&
                <LiquidityChartRangeInput
                  zoomLevel={ZOOM_LEVELS[fee ?? FeeAmount.MEDIUM]}
                  key={poolData?.address}
                  currencyA={token0}
                  currencyB={token1}
                  feeAmount={fee}
                  ticksAtLimit={ticksAtLimit}
                  price={Number(priceString(price, 8) ?? 0)}
                  priceLow24H={priceLow24H ? Number(priceString(priceLow24H, 8) ?? 0) : undefined}
                  priceHigh24H={priceHigh24H ? Number(priceString(priceHigh24H, 8) ?? 0) : undefined}
                  priceLower={priceLower}
                  priceUpper={priceUpper}
                  onBothRangeInput={onBothRangePriceInput}
                  onLeftRangeInput={onLeftRangePriceInput}
                  onRightRangeInput={onRightRangePriceInput}
                  formattedData={noLiquidity ? [] : formattedData}
                  isLoading={!noLiquidity && isChartDataLoading}
                  error={chartDataError}
                  interactive
                  dimensions={isMobile ? { width: 320 } : { width: 500 }}
                />
              }
              {
                !noLiquidity &&
                <FlexGap justifyContent="center" flexDirection="column">
                  <FlexGap gap="8px">
                    <Box borderRadius={4} bg="white" width={12} height={12} my={1} />
                    <Text fontSize="12px" color="textSubtle">Current price</Text>
                    <Text fontSize="12px">{price ? priceString(price, 6) : '-'}</Text>
                    <Text fontSize="12px">{currencyUnit}</Text>
                  </FlexGap>
                  <FlexGap gap="8px">
                    <Box borderRadius={4} bg="#B7ADD1" width={12} height={12} my={1} />
                    <Text fontSize="12px" color="textSubtle">24H Price range</Text>
                    <Text fontSize="12px">{priceLow24H ? priceString(priceLow24H, 6) : ''} - {priceHigh24H ? priceString(priceHigh24H, 6) : ''}</Text>
                    <Text fontSize="12px">{currencyUnit}</Text>
                  </FlexGap>
                </FlexGap>
              }
              <Box my={3}>
                <RangeSelector
                  priceLower={priceLower}
                  priceUpper={priceUpper}
                  getDecrementLower={inverted ? getIncrementUpper : getDecrementLower}
                  getIncrementLower={inverted ? getDecrementUpper : getIncrementLower}
                  getDecrementUpper={inverted ? getIncrementLower : getDecrementUpper}
                  getIncrementUpper={inverted ? getDecrementLower : getIncrementUpper}
                  onLeftRangeInput={onLeftRangePriceInput}
                  onRightRangeInput={onRightRangePriceInput}
                  currencyA={token0}
                  currencyB={token1}
                  feeAmount={fee}
                  ticksAtLimit={ticksAtLimit}
                  inverted={false}
                  disabled={formState.fullRange}
                />
              </Box>
              <FlexGap gap="8px" flexWrap="wrap" justifyContent="space-between" width="100%">
                <SettingsButton scale="sm" variant="tertiary" onClick={() => handleRefresh({ initialMax: 1.05, initialMin: 0.95 } as ZoomLevels)}>
                  {t("±%percent%%", { percent: 5 })}
                </SettingsButton>
                <SettingsButton scale="sm" variant="tertiary" onClick={() => handleRefresh({ initialMax: 1.1, initialMin: 0.9 } as ZoomLevels)}>
                  {t("±%percent%%", { percent: 10 })}
                </SettingsButton>
                <SettingsButton scale="sm" variant="tertiary" onClick={() => handleRefresh({ initialMax: 1.2, initialMin: 0.8 } as ZoomLevels)}>
                  {t("±%percent%%", { percent: 20 })}
                </SettingsButton>
                <SettingsButton scale="sm" variant="text" onClick={() => {
                  onSetFullRange(true)
                }}>
                  {t("Full Range")}
                </SettingsButton>
              </FlexGap>
              {
                !isDesktop &&
                <>
                  <Text fontSize={18} mt={4}>{t("Deposit Amount")}</Text>
                  <FlexGap alignItems="center" gap="8px" mt={1}>
                    <CurrencyLogo currency={currency0} />
                    <Text>{currency0?.symbol}</Text>
                    <Balance fontSize="14px" color="textSubtle" value={Number(currency0Balance?.toExact())} decimals={2} />
                  </FlexGap>
                  <LockedDeposit locked={depositADisabled}>
                    <CurrencyInput
                      currency={currency0}
                      value={formattedAmounts[Field.CURRENCY_A]}
                      onInput={onFieldAInput}
                    />
                  </LockedDeposit>
                  <FlexGap alignItems="center" gap="8px" mt={1}>
                    <CurrencyLogo currency={currency1} />
                    <Text>{currency1?.symbol}</Text>
                    <Balance fontSize="14px" color="textSubtle" value={Number(currency1Balance?.toExact())} decimals={2} />
                  </FlexGap>
                  <LockedDeposit locked={depositBDisabled}>
                    <CurrencyInput
                      currency={currency1}
                      value={formattedAmounts[Field.CURRENCY_B]}
                      onInput={onFieldBInput}
                    />
                  </LockedDeposit>
                </>
              }
              <Box mt={3}>
                <V3SubmitButton
                  addIsUnsupported={addIsUnsupported}
                  addIsWarning={addIsWarning}
                  account={account ?? undefined}
                  isWrongNetwork={Boolean(isWrongNetwork)}
                  approvalA={approvalA}
                  approvalB={approvalB}
                  isValid={!errorMessage && !invalidRange}
                  showApprovalA={showApprovalA}
                  approveACallback={approveACallback}
                  currentAllowanceA={currentAllowanceA}
                  revokeACallback={revokeACallback}
                  currencies={currencies}
                  showApprovalB={showApprovalB}
                  approveBCallback={approveBCallback}
                  currentAllowanceB={currentAllowanceB}
                  revokeBCallback={revokeBCallback}
                  parsedAmounts={parsedAmounts}
                  onClick={handleButtonSubmit}
                  attemptingTxn={attemptingTxn}
                  errorMessage={errorMessage}
                  buttonText={t('Deposit')}
                  depositADisabled={depositADisabled}
                  depositBDisabled={depositBDisabled}
                />
              </Box>
            </Box>
          </FlexGap>
        </LiquidityFormProvider>
      </ModalBody>
    </StyledModalContainer>
  )
}

export default IncreaseModal
